import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mobo-search',
  templateUrl: './search.component.html',
  styles: ``,
})
export class SearchComponent {
  @Input() placeholder: string = 'Buscar';
  @Input() isDelivery: Boolean = false;
  @Output() search = new EventEmitter();

  private _term: string = '';
  public get term(): string {
    return this._term;
  }
  public set term(v: string) {
    this._term = v;
    this.search.emit(v);
  }
}
